var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2632052"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,90.980392%,100%)",
      fillOpacity: 0
    },
    d: "M 2.707031 19.574219 L 2.707031 0.40625 L 12.90625 0.40625 L 17.273438 4.777344 L 17.273438 19.574219 Z M 2.707031 19.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,58.823529%,76.862745%)",
      fillOpacity: 1
    },
    d: "M 12.75 0.792969 L 16.890625 4.929688 L 16.890625 19.191406 L 3.089844 19.191406 L 3.089844 0.792969 L 12.75 0.792969 M 13.058594 0.0234375 L 2.324219 0.0234375 L 2.324219 19.957031 L 17.65625 19.957031 L 17.65625 4.625 Z M 13.058594 0.0234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.675781 5.007812 L 12.675781 0.40625 L 12.90625 0.40625 L 17.273438 4.777344 L 17.273438 5.007812 Z M 12.675781 5.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(45.490196%,58.823529%,76.862745%)",
      fillOpacity: 1
    },
    d: "M 13.058594 1.097656 L 16.585938 4.625 L 13.058594 4.625 L 13.058594 1.097656 M 13.058594 0.0234375 L 12.292969 0.0234375 L 12.292969 5.390625 L 17.65625 5.390625 L 17.65625 4.625 Z M 13.058594 0.0234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(30.588235%,47.843137%,70.980392%)",
      fillOpacity: 1
    },
    d: "M 10.375 13.824219 C 10.144531 13.824219 9.992188 13.671875 9.992188 13.441406 L 9.992188 7.691406 L 10.375 7.691406 C 11.601562 7.691406 12.828125 8.457031 12.90625 8.535156 C 13.058594 8.6875 13.132812 8.917969 12.980469 9.070312 C 12.828125 9.226562 12.597656 9.300781 12.445312 9.148438 C 12.445312 9.148438 11.601562 8.609375 10.757812 8.457031 L 10.757812 13.441406 C 10.757812 13.671875 10.605469 13.824219 10.375 13.824219 Z M 10.375 13.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.509804%,71.764706%,94.117647%)",
      fillOpacity: 1
    },
    d: "M 8.839844 11.90625 C 7.996094 11.90625 7.308594 12.59375 7.308594 13.441406 C 7.308594 14.289062 7.996094 14.976562 8.839844 14.976562 C 9.6875 14.976562 10.375 14.289062 10.375 13.441406 C 10.375 12.59375 9.6875 11.90625 8.839844 11.90625 Z M 8.839844 11.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(30.588235%,47.843137%,70.980392%)",
      fillOpacity: 1
    },
    d: "M 8.839844 12.292969 C 9.453125 12.292969 9.992188 12.828125 9.992188 13.441406 C 9.992188 14.054688 9.453125 14.589844 8.839844 14.589844 C 8.226562 14.589844 7.691406 14.054688 7.691406 13.441406 C 7.691406 12.828125 8.226562 12.292969 8.839844 12.292969 M 8.839844 11.523438 C 7.769531 11.523438 6.925781 12.367188 6.925781 13.441406 C 6.925781 14.515625 7.769531 15.359375 8.839844 15.359375 C 9.914062 15.359375 10.757812 14.515625 10.757812 13.441406 C 10.757812 12.367188 9.914062 11.523438 8.839844 11.523438 Z M 8.839844 11.523438 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.8f8c81d2.svg";
export { ForwardRef as ReactComponent };